/**
 * タスクのカテゴリ（checklist_template_items.task_category・monthly_checklist_tasks.task_category）。
 * 274（10/13 ユーザー判断）：旧PCRM と同じ自由入力の文字に戻した（区分値ではない）。下は入力欄に出す候補だけ。
 * - 旧の標準雛形のカテゴリ（契約書・稼働表・請求書・見積・注文書・業務完了報告書・BPLINK）と、新で使っていた 経費・支払・その他
 */
export const TASK_CATEGORY_MAX_LENGTH = 50;

export const TASK_CATEGORY_SUGGESTIONS: readonly string[] = [
  '契約書',
  '稼働表',
  '請求書',
  '見積',
  '注文書',
  '業務完了報告書',
  'BPLINK',
  '経費',
  '支払',
  'その他',
];
